module.exports = __webpack_public_path__ + "img/SS_V_Basic_Colorless.d2d66fe3.png";